export default {
  welcomeToCompass: "Welcome to",
  emailAddress: "Email Address",
  username: "Username",
  password: "Password",
  login: "Login",
  continue: "Continue",
  register: "Register",
  registerNow: "Register Now",
  noAccount: "Don't have an account?",
  done: "Done",
  error: "Error",
  redirectError: "Unfortunately the link to log into Compass is invalid or has expired. Please try again.",
  unknownError: "Unfortunately an unknown error has occurred",
  backButton: "Back",
  confirmationButton: {
    title: "Are you sure?",
    cancelButtonText: "Cancel",
    confirmationButtonText: "Confirm",
  },
  yes: "Yes",
  no: "No",
  trackRegister: "Want to track and access all your tickets?",
  accountCreateMsg: `Account details will be verified by the Speedcast team and you will receive an email when your account has been created.`,
  accountEmailDisclaimer: `Please note that only corporate or business email addresses will be approved for access to Compass. Personal email domains (e.g., Gmail, Yahoo, etc.) will not be accepted.`,
  kiboSSOWelcomeMsg:
    "Welcome to the Speedcast Compass Customer Portal. Your Shop Speedcast account enables access to Compass, delivering a complete online customer portal to manage all of your Speedcast services from a single platform.",
  kiboSSOError400: "We are sorry, but there was an error registering your user.",
  kiboSSOError403: "We are sorry, but there was an error registering your user.",
  kiboSSOError500: "We are sorry, but there was an error registering your user.",
  forgotPassword: "Forgot Password?",
  weCanEmailYouLinkToResetYourPassword: "We will email you a link to reset your password",
  cancel: "Cancel",
  close: "Close",
  moreInfo: "More Info",
  backToDetails: "Back to alert details",
  showAll: "Show All",
  passwordResetLinkExpired: "No password reset request found or link has expired",
  returnToLogin: "Return to Login",
  redirectingToLoginIn: "Redirecting to Login in",
  resetPassword: "Reset Password",
  enterNewPassword: "Enter new password",
  ifAnAccountExists: "You will receive a link to reset your password if an account exists for email: ",
  noPasswordResetFound: "No password reset request found or requested expired",
  // failed login messages
  "Session expired": "Session expired",
  "Access denied": "Access Denied",
  "Token not found": "Token not found",
  "Invalid Login": "Invalid Login",
  // register
  createAccount: "Create account",
  businessEmail: "Business Email",
  businessPhone: "Business Phone",
  mobilePhone: "Mobile Phone",
  iAgreeToThe: "I agree to the", // privacy policy and terms and conditions, which are links and translated below
  and: "and", // and for the agreement
  registerUserRequestForAccess:
    'We\'ve received your request for access.  Please allow 24-48 hours for review and approval.  You will receive an email once approved. For immediate assistance, please create a "Guest Support Ticket" or contact us at +1 (832) 668 2775.',
  backToLogin: "Back to Login",
  // guest ticket
  createGuestTicket: "Create Guest Support Ticket",
  phone: "Phone",
  siteVessel: "Site/Vessel",
  briefDescription: "Brief description of the issue",
  company: "Company",
  isRequired: " is required",
  ticketSubmitted: "Ticket has been submitted.",
  // Menu Bar
  mapView: "Map View",
  performance: "Performance",
  reports: "Reports",
  servicesOverview: "Services Overview",
  slaReports: "SLA Reports",
  ipslasOverview: "IPSLAs Overview",
  slasOverview: "SLAs Overview",
  starlinkOverview: "Starlink Overview",
  support: "Support",
  billing: "Billing",
  invoices: "Invoices",
  myAccount: "My Account",
  speedcastSettings: "Speedcast Settings",
  speedcastTeam: "Speedcast Team",
  speedcastDotCom: "Speedcast.com",
  speedcastDotComDescription: "Learn more about Speedcast's global solutions.",
  termsAndConditions: "Terms & Conditions",
  termsAndConditionsDescription: "Read Speedcast’s terms and conditions.",
  starlinkActivationTerms:
    "Submitted as a Customer Change Notice, activating the Starlink Service Plan to the Starlink Kit(s) listed above under the terms of the applicable Service Order.",
  starlinkEditServicesTerms:
    "Submitted as a Customer Change Notice, instructing Speedcast to make the requested changes to the Starlink Service Plans in use with the Starlink Kit(s) listed above, under the terms of the applicable Service Order.",
  permission: {
    denied: "You do not have permission to view this page. Please contact your administrator.",
    redirecting: "You will be redirected in {count} seconds...",
  },
  viewEdit: "View / Edit",
  privacyPolicy: "Privacy Policy",
  privacyPolicyDescription: "Understand how we handle personal data.",
  cookiePolicy: "Cookie Policy",
  cookiePolicyDescription: "Review how we use cookies across our website.",
  subscribeToNewsletter: "Subscribe to Newsletter",
  subscribeToNewsletterDescription: "Stay up to date with Speedcast news and events.",
  userGuide: "User Guide",
  userGuideDescription: "Detailed instructions on Compass Portal features.",
  starlinkGuide: "Starlink Management Guide",
  starlinkGuideDescription: "Step-by-step instructions for managing your Starlink services with Compass.",
  compassApiDoc: "API Documentation",
  compassApiDocDescription: "Compass API description document.",
  quickStartVideo: "Quick Start Video",
  quickStartVideoDescription: "An overview of basic Compass Portal usage.",
  welcomeVideo: "Welcome Video",
  welcomeVideoDescription: "A short welcome and portal overview.",
  compassPermissionVideo: "Compass Permission Video",
  compassPermissionVideoDescription: "How to manage user roles and permissions in Compass.",
  permissionsDoc: "Permissions Documentation",
  permissionsDocDescription: "Reference for user permissions in the Compass Portal.",
  loadingMoreResources: "Loading more resources",
  resources: "Resources",
  logout: "Logout",
  noServicesFoundForThisCompany: "No Services found for this company",
  viewModem: "View modem",
  manageMyServices: "Manage My Services",
  manageMyServicesAllSelected: "Please select a company to manage your services.",
  permissionsAllSelected: "Please select a company to manage your user permissions.",
  pendingActions: "Pending Actions",
  actions: "Actions",
  noActions: "No Actions",
  editServices: "Overview of Services",
  editUserAlerts: "Alerts",
  editUserPermission: "Permissions",
  openLink: "Open Link",
  notAvailableYet: "Not available yet",
  comingSoon: "Coming Soon",
  starlinkModemView: {
    dataUsageCurrentMonth: "Data usage for current month.",
    dataUsageDisclaimer: `Data usage tracking is not immediate and may be delayed by 24 hours or more.   Counting shown is for informational purposes only and final overages reflected in monthly invoice are accurate.`,
    priority: {
      optedIn: "Opt In",
      optedInTooltip:
        "Kit will continue to receive additional Priority Data  after exceeding included data. This will incur additional charges. Visit ‘Manage My Kit’ to change the status",
      optedOut: "Opt Out",
      optedOutTooltip:
        "Opt in to additional Priority Data to maintain network priority after exceeding included data. This will incur additional charges. Visit ‘Manage My Kit’ to change the status",
    },
  },
  noDataForPeriod: "No data for this time period",
  sigma: {
    menuManagement: "SIGMA",
    delete: "Delete",
    deleteDataPlanTitle: "Are you sure you want to delete the Free Data Plan?",
    cantBeUndone: "This action cannot be undone.",
    selectSite: "Select a site and device to configure the plan.",
    device: "Device",
    complementaryPlan: "Free Data Package",
    addComplementary: "Add Plan",
    noComplementaryPlan: "You don’t have any plan created yet \nClick on the “Add Plan” button above to start.",
    submit: "Submit",
    addPlan: "Add Free Data Plan",
    editPlan: "Edit Free Data Plan",
    sidebarTitle: "Select a site and device",
    placeholderModal: "Free internet. Best for email and browsing",
  },
  // Starlink
  starlink: {
    continueInBackground: "Continue in the background",
    errorChangeKitStatus: "Could not change kit {kitId}",
    errorDeactivateKit: "Could not deactivate kit {kitId}",
    errorSuspendKit: "Could not suspend kit {kitId}",
    errorResumeKit: "Could not resume kit {kitId}",
    errorActivateKit: "Could not activate kit {kitId}",
    updateMsg: "Kit {kitId} has been updated",
    menuManagement: "Starlink",
    actionButtonSelect: {
      label: "No Change",
      btnAction: "Apply",
      deactivate: "Deactivate",
      suspend: "Suspend",
      resume: "Resume",
      activate: "Activate",
    },
    servicePlanUsage: "Service Plan Usage",
    monthlyUsageTooltip: "Usage by each kit on the plan per day",
    sharedPlanDesc: "This kit is on a shared plan: ",
    kitUsage: "Kit Usage",
    planUsage: "Plan Usage",
    lastSignal: "Last Signal Reading",
    planAllowance: "Plan Allowance",
    usageLimit: "Usage Limit",
    alertRepeatsInfo: `If checked, the alert will be triggered every time the threshold is reached`,
    alertEmailPlaceholder: "Alerts will be sent to this email(s)",
    emailMax: "Maximum 3 emails allowed",
    emailHint: "Add at least one email and up to three emails",
    alertType: "Alert Type",
    sliderInfo: "The slider sets the alert's threshold",
    sliderInfoInput: "(the input as well)",
    sliderInfoEmpty_1: "This alert type does not need a threshold,",
    sliderInfoEmpty_2: "it gets triggered when the usage limit is reached",
    noActivationList: "Click on the “Add Kit” button above to start.",
    addKit: "Add Kit",
    activateKits: "Activate Kits",
    deleteActivationKit: "Are you sure you want to delete this Kit from the activation list?",
    editKit: "Edit Kit",
    activationForm: {
      detailsTitle: "Details",
      optInOutDescription: "Opt In for Priority Bandwidth Excess Usage",
      optInOutDescriptionMobile: "* For mobile plans please contact support if you wish to Opt In",
      selectKitAndPlan: "Select first a Kit and Plan",
      createNewSite: "Create New Site",
      newSite: "New Site",
      kitEditedSuccessfully: "Kit edited successfully",
      kitAddedActivation: "Kit added to activation list",
      errorValidatingAddress: "Error while validating address, please try again or select an existing site",
      changeSite: "Existing Site",
      addressTitle: "Address",
      addressSubtitle: "Please provide the address for the new site",
      newSiteSubtitle: "Please provide the name for the new site",
    },
    kitDetails: "Kit Details",
    noData: "No Data",
    activatedDate: "Activated Date",
    planDetails: "Plan Details",
    currentPlan: "Current Plan",
    pendingPlanChanges: "Pending Plan Changes",
    cancelPendingPlanChange: "Cancel pending plan change",
    none: "None",
    priorityOptIn: "Priority Opt In",
    viewTelemetry: "View Telemetry",
    optedIn: "Opted In",
    optedOut: "Opted Out",
    optIn: "Opt In",
    optOut: "Opt Out",
    optInDisclaimer:
      "Additional usage based charges will apply to traffic which exceeds the plan’s priority access threshold. By confirming you agree to additional charges from any overage data. This kit will remain opted in to priority overage data until you opt out.",
    optOutDisclaimer:
      "Data traffic in excess of the applicable priority access threshold will be throttled. By confirming you acknowledge you may experience slower throughput speeds.",
    optInLimitMessage: "Please note: Changes to a kit's data overage status can only be made once per 24 hour period.",
    optInLocked: "Priority Data Change Lock",
    optInLockedMessage:
      "Priority data changes can only be made once per 24 hour period. Please try again 24 hours after the latest change.",
    optInLockedLatest: "Latest change: ",
    speedcastUser: "Speedcast User",
    speedcastChangeLock:
      "Speedcast users are unable to make service changes in Compass at this time. Please ensure the account has a customer admin and request that the customer log in to Compass and make the required changes so they can be logged.",
    deactivateTitle: "Deactivate Kit",
    deactivateConfirmation: "Please confirm that you would like to deactivate this kit.",
    ipVisibilityChange: "IP Visibility Change",
    recentChangesTitle: "Recent Changes",
    noRecentChanges: "No Recent Changes",
    recentChangesColumns: {
      name: "Name",
      username: "Username",
      action: "Action",
      date: "Date",
    },
    aboutAlerts: "About Starlink Alerts",
    historicalAlerts: "Historical Alerts",
    activeAlertsDesc:
      "Alerts will persist for as long as they are active and the kit continues to report telemetry data via the Starlink API. If a kit has stopped reporting data you can use the Alerts Timeline Widget to get a historical look at the last alerts that were being reported.",
    allAlertsInfo: "This is the current list of Starlink alerts that can be returned from Starlink.",
    alertStorageInfo:
      "Alerts are triggered if the condition was met at least once in the previous 15 seconds on the kit but may take several minutes to be passed to Speedcast. Speedcast stores these alerts and shows alerts active within the last 5 minute for kits that have been online and reporting data in that timeframe.",
    noAlertSelection: "No Alert Selected",
  },
  activateKitsSplashTitle: "Starlink Management",
  // TODO: Update after CP-1261 - "How to handle Contact Information" - is solved, review if activate kits texts need to be defined as white-labeled
  activateKitsSplashText:
    "The following pages allow you to activate Kits, confirm or amend a Service Plan, Opt In or Opt Out of Additional Priority data, and Pause, Resume or Deactivate a Service Plan. By using Compass, you are notifying Speedcast of the changes you require, and Speedcast will invoice you under the terms of your contract accordingly. Please ensure that the Personnel using Compass are authorized to make changes on behalf of your company and to send and receive notices in relation to the Services under the contract.",
  activateKits: "Activate Your Kits",
  kitAddressTooltip:
    "Please select the kit serial number before adding the address details. The address must be the kit location at the time of activation.",
  kitNameTooltip: `Speedcast recommends using the vessel name or site location as a unique identifier for each activated kit. Example: "Home-001", "Office-002".`,
  activateKitsColSiteName: "Site Name or Vessel",
  activateKitsColKitId: "Kit Serial Number",
  activateKitsColName: "Kit Name",
  activateKitsColPlan: "Starlink Plan",
  activateKitsColAddress: "Address",
  selectKitFirst: "Enter location address",
  addAddress: "Add Address",
  editAddress: "Edit Address",
  addressSet: "Address Set",
  enterAddressForKit: "Enter Address for Kit",
  addressLine1: "Address Line 1",
  addressLine2: "Address Line 2",
  addressLine3: "Address Line 3",
  city: "City",
  stateProvince: "State/Province",
  zipPostal: "Zip/Postal Code",
  country: "Country",
  clickingSubmit: "Clicking Submit will send address to Starlink for service capacity check.",
  submittingAddress: "Submitting address...",
  addressSubmittedAwaiting: "Address submitted, awaiting confirmation (~30 seconds)...",
  gettingAddressID: "Getting new address ID...",
  checkingStarlinkCapacity: "Checking Starlink Capacity...",
  errorAddingAddress: "Error adding address.",
  addressNotAccepted: "Address not accepted, correct address and try again.",
  noStarlinkCapacity: "Unfortunately there is no Starlink capacity at this location.",
  kitMustBeActivatedInCountry:
    "Kit must be activated in the country it's account is assigned to.  Contact Speedcast support to change kit's assigned account.",
  removeRow: "Remove Row",
  editKitName: "Edit the Kit Name",
  maximum50Characters: "Maximum 50 characters",
  pleaseMaximum50Characters: "Please use maximum 50 characters",
  pendingPlanChangesMessage: "Requested downgrades will be executed at the beginning of the next month",
  priorityAccessData: "Priority Access Data",
  priorityAccessDataOptIn: `Opt-in:  Additional Usage Based Charges will apply to Customer traffic which exceeds the Service Plan’s Priority Access threshold.`,
  priorityAccessDataOptOut: `Opt-out:  Data traffic in excess of the applicable Priority Access threshold will be throttled.`,
  optInUnavailable:
    "Setting Opt-in status is currently unavailable from Compass for mobile plans. Please contact Speedcast support to choose to Opt In to priority overage data.",
  kitActivationSummary: "Kit Activation Summary",
  activateKitsSummaryColKitId: "Kit Id",
  activateKitsSummaryColSiteName: "Site/Vessel Name",
  activateKitsSummaryColName: "Kit Name",
  activateKitsSummaryColPlan: "Plan",
  activateKitsSummaryColOptIn: "Opt In",
  myPlansTitle: "My Plans",
  myStarlinkServices: "My Starlink Services",
  activityHistory: "Activity History",
  agree: "I agree to the activation ",
  submittingKitsActivation: "Activating kits...",
  errorActivationKits: "Error activating kits.",
  errorActivateKitsSummary: "Unfortunately, there was an issue while activating your kit(s).",
  errorActivateKitsContactInformation:
    "Please call +1-305-627-6010 (Option 2) and for assistance.  We are also available via WhatsApp at +51-952-066-452.",
  submittingIPVisibilityRequest: "Submitting the request...",
  errorIPVisibilityRequest: "Error submitting request.",
  confirmOptOut: "You are about to Opt Out of additional Priority data. Are you sure?",
  confirmOptIn: "You are about to Opt In for additional Priority data. Are you sure?",
  // Statistics
  latency: "Latency",
  uploadSpeed: "Upload Speed",
  uploadCIR: "Upload CIR",
  downloadSpeed: "Download Speed",
  downloadCIR: "Download CIR",
  logonState: "Logon State",
  // iDirect
  modemUptimeTooltip: "Uptime of the modem OS",
  // User
  firstName: "First Name",
  lastName: "Last Name",
  currentPassword: "Current Password",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  updatePassword: "Update Password",
  passwordRequirements: "Password Requirements",
  minimumEightCharacters: "Minimum 8 Characters",
  maximumFortyCharacters: "Maximum 40 Characters",
  atLeastOneLowerCaseLetter: "At least 1 lowercase letter",
  atLeastOneUppercaseLetter: "At least 1 uppercase letter",
  atLeastOneDigit: "At least 1 digit",
  passwordChanged: "Password Changed",
  setupMultiFactorAuthentication: "Setup Multi-Factor Authentication",
  light: "Light",
  dark: "Dark",
  selectACompany: "Select a Company",
  //My Account
  changePassword: "Change Password",
  profile: "Profile",
  uiTheme: "UI Theme",
  photo: "Photo",
  language: "Language",
  languageSelection: "Language Selection",
  startPage: "Start Page",
  dashboards: "Dashboards",
  // Dashboard Page
  dashboardPage: {
    heading: "My Dashboards",
    newBtn: "New Dashboard",
    titlePlaceholder: "Dashboard Title",
    createdLabel: "Created:",
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    editHeading: "Edit Dashboard",
    empty: "No dashboards yet. Click New Dashboard to get started.",
    deleteConfirm: "Delete “{title}”?",
    backToList: "Back to dashboards list",
    goToDashboard: "Go to Dashboard",
  },
  // Tickets
  tickets: "Cases",
  ticketCase: "Case",
  created: "created",
  casesTitle: "Cases",
  searchCases: "Search Cases...",
  changeRequests: "Change Requests",
  supportGuide: "Support Guide",
  supportGuideDescription: "Access the Speedcast Global NOC - Customer Service Guide.",
  viewTicket: "View Cases",
  newTicket: "New case",
  errorCreatingNewCase: "Error creating new case.",
  addNewMessage: "Add new message",
  loadMore: "Load more",
  status: {
    resolved: "resolved",
    pending: "pending",
  },
  statusTitle: "Status",
  comments: "Comments",
  attachments: "Attachments",
  requestCreated: "Created",
  createdBy: "Created by",
  priorityTitle: "Priority",
  notSet: "Not Set",
  updated: "updated",
  ago: "ago",
  details: "Details",
  ticket: {
    create: {
      ticket: "Create case",
      description:
        "   Please provide the details of your request. A member of our team will respond at the earliest. (All fields are required).",
      submit: "Submitting case...",
    },
    status: {
      New: "New",
      "In Progress": "In Progress",
      "On Hold": "On Hold",
      "Service Restored": "Service Restored",
      Resolved: "Resolved",
      Open: "Open",
      Closed: "Closed",
      Cancelled: "Cancelled",
      "Awaiting Info": "Awaiting Info",
      "Not Set": "Not Set",
    },
    priority: {
      Normal: "Normal",
      Moderate: "Moderate",
      High: "High",
      Critical: "Critical",
      "Not Set": "Not Set",
    },
    company: {
      label: "Company",
    },
    email: {
      label: "Email Address",
      hint: "The email that will receive notifications",
    },
    site: {
      label: "Site affected (Optional)",
      required: "Site must be selected.",
    },
    subject: {
      label: "How can we help you?",
      hint: "Brief summary of the issue",
      required: "Subject must be filled in.",
    },
    description: {
      label: "Description",
      hint: "Detailed account of the issue...",
      required: "Description must be filled in.",
    },
    submitText: "Submit",
    backToList: "Back to Case list",
  },
  changeRequest: {
    create: {
      changeRequest: "Create change request",
      description:
        "   Please provide the details of your request. A member of our team will respond at the earliest. (All fields are required).",
      submit: "Submitting change request...",
    },
    status: {
      Review: "Review",
      Implement: "Implement",
      Scheduled: "Scheduled",
      Authorize: "Authorize",
      Assess: "Assess",
      New: "New",
      Closed: "Closed",
      Cancelled: "Cancelled",
      Canceled: "Cancelled",
    },
    company: {
      label: "Company",
    },
    email: {
      label: "Email Address",
      hint: "The email that will receive notifications",
    },
    site: {
      label: "Site affected",
      required: "Site must be selected.",
    },
    subject: {
      label: "How can we help you?",
      hint: "Brief summary of the issue",
      required: "Subject must be filled in.",
    },
    description: {
      label: "Description",
      hint: "Detailed account of the issue...",
      required: "Description must be filled in.",
    },
    submitText: "Submit",
    backToList: "Back to change request list",
  },
  // ACU
  Azimuth: "Azimuth",
  "Azimuth (Rel.)": "Azimuth (Rel.)",
  Elevation: "Elevation",
  Heading: "Heading",
  blockageStatus: "Blockage Status",
  blockedStatus: "Blocked",
  clearStatus: "Clear",
  valueACU: "Value",

  submit: "Submit",
  submitting: "Submitting...",
  fileSizeError: "Files must be less than 10MB",
  optional: "optional",
  showGraphs: "Show Graphs",
  hideGraphs: "Hide Graphs",
  selectService: "Select a Service",
  selectDevice: "Select a Device",
  showingResultsAcross: "Showing results across {n} services",
  showingResultsAcrossOne: "Showing results across 1 service",
  export: "Export",
  download: "Download",
  availability: "Availability",
  Memory: "Memory",
  jitter: "Jitter",
  packetLoss: "Packet Loss",
  throughput: "Throughput",
  responseTime: "Response Time",
  percentLoss: "Percent Loss",
  noData: "No Data Available",
  router: "Router",
  switch: "Switch",
  acu: "ACU",
  ipInterface: "IP Interface",
  wanAccelerator: "WAN Accelerator",
  send: "Send",
  expandMap: "Expand Map",
  locationInfo: "Location Info",
  locationAccuracy: {
    starlink:
      "The location data provided by Starlink is approximate and is displayed for informational purposes. It should not be relied upon for fixed site address or accurate vessel location.",
    "starlink-detail":
      'Starlink uses a geospatial hexagonal grid with limited resolution to track kits. The kit’s location is communicated by the ID of a hexagon on the grid, whose center is calculated and shown on the map. See the <a href="https://h3geo.org/docs/" target="_blank" rel="noopener noreferrer">introduction</a> for how H3 indexing works, and <a href="https://h3geo.org/docs/library/index/cell/" target="_blank" rel="noopener noreferrer">cell mode</a> for details on individual H3 cells.<br><br> Each cell is colour-filled as a heat map where the color gradients indicate relative amount of time spent in the cell: <span style="color:#00c600; font-weight:700">green</span> means less time in the cell, <span style="color:#ffc800;font-weight:700">yellow</span> gradients indicate more time, and <span style="color:#ff0000;font-weight:700">red</span> shows the most time spent relative to the other points on the map. The outlined cell shows the kit’s most recent reported location.',
    idirect:
      "The location displayed is the last communicated GPS coordinates reported by the modem. Location data may be delayed or missing.",
    newtec:
      "The location displayed is from a variety of sources to get the most recent location for the modem. Location data may be missing if the modem is not reporting location or if reporting has been turned off.",
    uhp: "Location data is provided by the UHP NMS using the UHP API and may be missing or delayed if there are communication issues with the NMS.",
  },
  errorMessages: {
    genericShort: "Something went wrong",
    genericLong: "Something went wrong and we were unable to get the requested data",
    genericTryAgain: "Something went wrong and we were unable to get the requested data, please try again later",
    noData: "No Data Available",
    noUsageData: "No Usage Data Available",
    noDataExplanation: "There is no telemetry data available for this modem",
    contact: "If the error persists, please contact the service desk",
    code: "Error code",
    noStarlinkKitsData: "There are no Starlink kits available for activation at this time.",
    noPricePlansData: "There are no Starlink pricing plans available to your account at this time.",
  },
  starlinkNoDataInfo: {
    invalidSerial: "The kit serial number contains unexpected characters. Please contact support.",
    deactivated: "This kit is currently deactivated and will not report usage data.",
    disabled: "This kit is currently disabled by Starlink. {alert}",
    noUsage:
      "Starlink is not reporting any usage data. Ensure the kit is activated and online. Data may take up to 6 hours to appear after activation.",
    noTelemetry:
      "No telemetry in the last 24h. Ensure the kit is online with a clear view of the sky. Use the date picker to inspect older data.",
  },
  errorAction: {
    loadingServices: "loading services",
    loadingUsers: "loading users",
  },
  rolesEditUserPermissions: "{company} Permissions",
  rolesEditAlerts: "Edit Alerts",
  rolesEmailAddress: "Email Address",
  rolesAddNewUser: "Add new user",
  rolesSuccessful: "The changes were submitted successfully",
  rolesError: "Something went wrong and we were unable to change the roles",
  availability_graph_title: "Availability",
  availability_table_title: "Outages",
  availability_error: "Something went wrong and we were unable to retrieve the availability.",
  outages: "Outages",
  lastMonth: "Last Month",
  thisMonth: "This Month",
  timestamp: "Timestamp",
  period: "Period",
  // OFFICIAL STARLINK TELEMETRY ALERTS - DO NOT EDIT UNLESS STARLINK UPDATES THEIR ALERT CODES
  starlinkAlerts: {
    activeAlerts: "Active Alerts",
    actuator_motor_stuck: {
      label: "Actuator Motor Stuck",
      description: "The Starlink actuator motor is stuck",
      detail:
        "For actuated Starlink devices, the actuator motor is jammed and is not able to align the Starlink antenna to the desired angle. This can cause reduced performance, or the Starlink may not be able to connect to the network if the tilt too far from nominal.",
    },
    data_overage_rate_limited: {
      label: "Data Overage Rate Limited",
      description: "Starlink is rate limited as it is out of priority data",
      detail:
        "Starlink is rate limited as it is out of priority data. Add more by topping up or enabling automatic top-up.",
    },
    disabled_account_disabled: {
      label: "Disabled Account Disabled",
      description: "Service is disabled because the Starlink's account is disabled",
      detail:
        "The Starlink device will be disabled if the account it is on is also disabled. Please log in to this account to get more information on the restriction.",
    },
    disabled_blocked_country: {
      label: "Disabled Blocked Country",
      description: "Service is disabled because the Starlink is in a restricted service country",
      detail:
        "The Starlink device has moved to a country where Starlink is either not enabled or the service plan is limited to a specific region. If Starlink is coverage is enabled, upgrade to a Mobile Global or Mobile Priority Service plan. Or opt-in for Mobile Priority Data.",
    },
    disabled_cell_is_disabled: {
      label: "Disabled Cell Is Disabled",
      description: "Service is disabled because the Starlink is in a cell that will not get beams",
      detail:
        "The Starlink device has moved to a cell that Starlink does not serve. The current cell will not get beams for service.",
    },
    disabled_data_usage_exceeded_quota: {
      label: "Disabled Data Usage Exceeded Quota",
      description: "Service is disabled because the Starlink has exceeded the data usage quota",
      detail:
        "The Starlink device has been disabled as data usage has exceeded the data quota. If Starlink coverage is enabled, upgrade your plan to a higher quota.",
    },
    disabled_invalid_country: {
      label: "Disabled Invalid Country",
      description: "Service is disabled because the Starlink is in an unsupported country",
      detail:
        "The Starlink device has moved to a country where Starlink is either not enabled or the service plan is limited to a specific region. If Starlink coverage is enabled, opt-in for Mobile Priority Data or upgrade to a Mobile Global or Mobile Priority Service plan.",
    },
    disabled_moving_too_fast: {
      label: "Disabled - Moving too Fast",
      description: "Service is disabled because the Starlink is moving too fast without an aviation service plan",
      detail:
        "The Starlink device is moving faster than the configured policy allows and service has been disabled. Update the service plan to one which supports higher speeds.",
    },
    disabled_moving_while_not_mobile: {
      label: "Disabled - Moving while not Mobile",
      description: "Service is disabled because the Starlink is moving without a mobile service",
      detail:
        "The Starlink device is moving at greater than 10 MPH (4.4. meters per second) and service has been disabled. Update the service plan to a Mobile Priority service plan. Or opt-in for Mobile Priority Data.",
    },
    disabled_no_active_account: {
      label: "Disabled - No Active Account",
      description: "Service is disabled because the account or associated service line is not active",
      detail:
        "The account associated with the Starlink device is not active or has been disabled. Check that the account is active and in good standing. Ensure that payment details are setup and no outstanding unpaid invoices have caused the service to be disabled.",
    },
    disabled_no_active_service_line: {
      label: "Disabled - No Active Service Line",
      description: "Service is disabled because the account or associated service line is not active",
      detail:
        "The service line associated with the Starlink device is not active or has been cancelled. Check that the service line is active and the account is in good standing. Ensure that payment details are setup and no outstanding unpaid invoices have caused the service to be disabled.",
    },
    disabled_no_service_in_ocean: {
      label: "Disabled - No Service in Ocean",
      description: "Service is disabled because the Starlink is in the ocean without a service that supports maritime",
      detail:
        "The Starlink device has moved into ocean coverage and does not have mobile priority data available. Update service plans to a Mobile Priority plan with additional data, or opt-in for Mobile Priority Data if you are on a mobile plan and have exceeded the Mobile Priority Data limit.",
    },
    disabled_roam_restricted: {
      label: "Disabled Roam Restricted",
      description: "Service is disabled because the Starlink has roamed for too long outside of its home country",
      detail:
        "The Starlink device is being georestricted after roaming for too long in a country that is not the roaming terminal's home country. Restriction is not imposed if the user is in their home country.",
    },
    disabled_too_far_from_service_address: {
      label: "Disabled - Too Far from Service Address",
      description: "Service is disabled because the Starlink is too far from the service address",
      detail:
        "The Starlink device has moved too far from the service location on the account. Update the service address to resume service.",
    },
    disabled_unknown_location: {
      label: "Disabled Unknown Location",
      description: "Service is disabled because the Starlink cannot determine its location",
      detail: "The Starlink device cannot determine its location and cannot receive service.",
    },
    disabled_unlicensed_country: {
      label: "Disabled Unlicensed Country",
      description: "The Starlink device is in an unlicensed country and has been disabled.",
      detail:
        "The Starlink device is in an unlicensed country and has been disabled. The Starlink's policy prohibits being served in unlicensed countries.",
    },
    disabled_unsupported_country: {
      label: "Disabled - Unsupported Country",
      description: "Service is disabled because the Starlink is in an unsupported country",
      detail:
        "The Starlink device has moved to a country where Starlink is either not enabled or the service plan is limited to a specific region. If Starlink is coverage is enabled, upgrade to a Mobile Global or Mobile Priority Service plan. Or opt-in for Mobile Priority Data.",
    },
    disabled_unsupported_version: {
      label: "Disabled Unsupported Version",
      description: "The Starlink's software version is not supported",
      detail:
        "The Starlink's software version is unsupported. This can happen if the Starlink has been offline for a while. Please submit a ticket if the issue persists.",
    },
    ethernet_slow_100mbps: {
      label: "Ethernet Slow 100mbps",
      description: "Ethernet link speed is negotiated to 100 Mbps",
      detail:
        "The ethernet link has auto negotiated to 100 Mbps. The Starlink device should auto negotiate to 1000 Mbps. There may be a cable or connection issue. Make sure the client device port is configured to 1000 Mbps auto-negotiation.",
    },
    ethernet_slow_10mbps: {
      label: "Ethernet Slow 10mbps",
      description: "Ethernet link speed is negotiated to 10 Mbps",
      detail:
        "This alert indicates that the ethernet link has auto negotiated to 10 Mbps. The Starlink device should auto negotiate to 1000 Mbps. There may be a cable or connection issue. Make sure the client device port is configured to 1000 Mbps auto-negotiation.",
    },
    high_sky_obstruction: {
      label: "High Sky Obstruction",
      description: "The Starlink is detecting an obstruction in the field of view",
      detail:
        "The Starlink device detected a high percentage of the sky with available satellites is obstructed. The high sky percent obstruction alert is a leading indicator that the Starlink device is detecting potential obstructions. The alert does not track percent time the Starlink device was disconnected from the network. See high_time_obstruction for alert for tracking connection interruptions. This alert will be set if 0.50% of the Starlink field of view is obstructed. Check that the Starlink is in an unobstructed location in all directions.",
    },
    high_sky_obstruction_mobile: {
      label: "High Sky Obstruction (Mobile)",
      description: "The Starlink is detecting an obstruction in the field of view while moving",
      detail:
        "The Starlink device detected a high percentage of the sky with available satellites is obstructed. The high sky percent obstruction alert is a leading indicator that the Starlink device is detecting potential obstructions. The alert does not track percent time the Starlink device was disconnected from the network. See high_time_obstruction for alert for tracking connection interruptions. This alert will be set if 0.50% of the Starlink field of view is obstructed. Check that the Starlink is in an unobstructed location in all directions.",
    },
    high_time_obstruction: {
      label: "High Time Obstruction",
      description: "The Starlink is detecting a frequent obstruction in the field of view",
      detail:
        "The Starlink device detected a high percentage of the time when the Starlink device was not able to make a connection to a satellite. The high time obstruction alert is an indicator of the time that Starlink was unable to successfully make a connection and the connection was dropped. This alert will be set if 0.27% of the time Starlink field of view is obstructed. Check that the Starlink is in an unobstructed location in all directions.",
    },
    high_time_obstruction_mobile: {
      label: "High Time Obstruction (Mobile)",
      description: "The Starlink is detecting a frequent obstruction in the field of view while moving",
      detail:
        "The Starlink device detected a high percentage of the time when the Starlink device was not able to make a connection to a satellite. The high time obstruction alert is an indicator of the time that Starlink was unable to successfully make a connection and the connection was dropped. This alert will be set if 0.27% of the time Starlink field of view is obstructed. Check that the Starlink is in an unobstructed location in all directions.",
    },
    info: {
      trigger: "Alerts are triggered if the condition was met at least once the previous 15 seconds.",
      persist: "Alerts will persist for as long as they are active.",
      update: "Alerts will auto update.",
    },
    mast_not_vertical: {
      label: "Mast not Vertical",
      description: "The Starlink is not installed with the mast within 30 degrees off vertical",
      detail:
        "For actuated Starlink devices, the Starlink alignment system is not able to align the Starlink antenna to the desired angle because the mast is greater than 30 degrees from vertical. This may cause poor performance, or the Starlink device may not be able to connect to the network unless corrected.",
    },
    moving_while_not_mobile: {
      label: "Moving While Not Mobile",
      description: "Service is disabled because the Starlink is moving without a mobile service",
      detail:
        "The Starlink device is moving at greater than 10 MPH (4.4. meters per second) and service has been disabled. Update the service plan to a Mobile Priority service plan. Or opt-in for Mobile Priority Data.",
    },
    noAlerts: "No Active Alerts",
    pop_change: {
      label: "PoP Change",
      description:
        "Starlink point of presence (PoP) location changed. This may cause a short disconnect and IP address change",
      detail:
        "The Starlink point of presence (PoP) has changed and as a result the Starlink will have a new IP address assigned for that region.",
    },
    power_disconnect_detected: {
      label: "Power Disconnect Detected",
      description: "The Starlink detected that the previous reboot was caused by a loss of power",
      detail: "The Starlink will report this alert when recovering from an unexpectedly power disconnect.",
    },
    power_supply_thermal_throttling: {
      label: "Power Supply Thermal Throttling",
      description: "The power supply is signaling that it is very hot and close to shutting down",
      detail:
        "The power supply is exceeding it's upper safety thermal threshold. As a result, the Starlink is throttling itself to reduce its power draw and let the power brick cool down.",
    },
    software_update_reboot_pending: {
      label: "Software Update Reboot Pending",
      description: "Starlink software update is pending and will reboot at 3 AM local time (+/- 30 minutes)",
      detail:
        "The Starlink device has downloaded a software update and is scheduled to reboot at 3 AM local time +/- 30 minutes. Local time is based on the current physical location of the Starlink hardware. After this alert is triggered, a manual reboot will also update the software if the scheduled time is inconvenient.",
    },
    thermal_shutdown: {
      label: "Thermal Shutdown",
      description: "The Starlink has exceeded the max temperature thresholds - needs a reboot to recover",
      detail:
        "The Starlink device has reached the maximum temperature threshold and has stopped service to cool down. Service will resume when the Starlink device reaches a nominal operating temperature. Starlink devices are designed to operation nominally when the ambient temperature is below 50 degrees Celsius. In extreme cases the Starlink will reboot in order to recover. Physically check that the Starlink device is installed in a location that is properly ventilated and not exposed to external heat sources, e.g. near an exhaust vent.",
    },
    thermal_throttle: {
      label: "Thermal Throttle",
      description:
        "The Starlink has exceeded high temperature thresholds and will reduce performance to lower temperature",
      detail:
        "The Starlink device has reached a high temperature threshold and is throttling performance to cool down. Performance will improve when the Starlink device reaches a nominal operating temperature. Starlink devices are designed to operation nominally when the ambient temperature is below 50 degrees Celsius. Physically check that the Starlink device is installed in a location that is properly ventilated and not exposed to external heat sources e.g. near an exhaust vent.",
    },
    thermal_throttling: {
      label: "Thermal Throttling",
      description:
        "The Starlink has exceeded high temperature thresholds and will reduce performance to lower temperature",
      detail:
        "The Starlink device has reached a high temperature threshold and is throttling performance to cool down. Performance will improve when the Starlink device reaches a nominal operating temperature. Starlink devices are designed to operation nominally when the ambient temperature is below 50 degrees Celsius. Physically check that the Starlink device is installed in a location that is properly ventilated and not exposed to external heat sources e.g. near an exhaust vent.",
    },
    unable_to_align: {
      label: "Unable to Align",
      description: "Unable to align to desired tilt direction",
      detail:
        "The Starlink device is installed in a location that it's not able to align the antenna to the desired angle. This may cause poor performance, or the Starlink device may not be able to connect to the network unless corrected. If the Starlink device has an actuator motor, physically inspect the Starlink install to ensure that the motor is functioning correctly by stowing and un-stowing the Starlink from the Starlink mobile app. If the Starlink device is a Flat mount un-actuated model, check that the Starlink is securely attached to a horizontal surface.",
    },
  },
  today: "Today",
  yesterday: "Yesterday",
  last7days: "Last 7 Days",
  last30days: "Last 30 Days",
  home: {
    starlinkMsg:
      "The location data provided by Starlink and displayed on the map provides an approximate location and should not be relied upon for the purpose of fixed site address or vessel location.",
  },
  networkTools: {
    networkTools: "Network Tools",
    beamFootprints: "Beam Footprints",
    satellites: "Satellites",
    teleports: "Teleports",
  },
  map: {
    map3d: "Map 3D",
    map2d: "Map 2D",
    legend: {
      ok: "Ok",
      warning: "Warning",
      alarm: "Alarm",
      noStatus: "No Status",
    },
  },
  modemStatus: {
    outdatedExplanation: "data is more than 1 hour old",
  },
  userPermission: {
    addNewUser: "Add New User",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    contactRelationships: "Company Assignment (Optional)",
    grantedRoles: "Role Assignment (Optional)",
    contactRelationshipsNote:
      "By default, a user on a parent account has access to all child accounts. If you would like to limit a user’s access to specific companies, please select them.",
    grantedRolesNote:
      "By default, a user has basic permissions. If you would like to grant additional roles to a user, please select them.",
    deleteUser: {
      title: "Delete User",
      description: "Are you sure you want to delete this user?",
      confirm: "Delete",
      cancel: "Cancel",
      action: "This will delete the user and all associated attributes.",
      remove:
        "This will remove the user's access to this company. User may continue to have access to other companies in the organization. To view or delete the user entirely visit",
    },
    admin: {
      title: "Admin",
      action: "Make Admin",
      noPermission: "You do not have permission to assign an Admin role to this user.",
      remove: "Remove Admin",
      accountsMismatch: "Account access mismatch",
    },
  },
  //popup messages
  popupPlanChange: {
    title: "Change the plan of your kit",
    description: "You are about to {action} your current plan",
    detailFirstOfMonth: "Your changes will take effect immediately.",
    detailNotFirstOfMonth: "Your changes will take effect on the 1st of {month}.",
    detailInvalidChange:
      "Switching between fixed and mobile plans is not available in Compass. Please contact our support team for assistance.",
    disclaimer: "*Additional fees may apply",
    success: "Your plan was updated successfully",
    error: "Your plan was not updated",
    btn_accept: "Confirm selection",
    scheduled: "Downgrade successfully scheduled",
    submittedAt: "Scheduled at: ",
    deletePlanChangeRequestSuccess: "Successfully removed request for plan change",
    deletePlanChangeRequestError: "Could not remove request for plan change",
  },
  starlinkAlertsReport: {
    usageMenuLabel: "Starlink Usage",
    alertsMenuLabel: "Starlink Active Alerts",
    pageTitle: "Select a Report",
    title: "All Modem Alerts",
    modemsPerPage: "Modems per page",
    activeLabel: "Active",
    modemsColumnName: "Kit",
    businessServiceColumnName: "Service",
    noActiveAlerts: "There are no active alerts for the requested kits",
  },
  servicesOverviewComponent: {
    successSpeedToggle: "Preferred speed saved to preferences",
    errorSpeedToggle: "Error saving speed preference",
    usageReportSearchBox: "Find by Service or Kit",
  },
  changeRequestsComponent: {
    searchChangeRequests: "Find Request...",
  },
  userRoles: {
    faq: "FAQ",
  },
  adminBanners: {
    accountAdminRoleInfo1: "Your Admin manages your account.",
    accountAdminRoleInfo2: "Contact your Admin to change your user permissions.",
    learnMore: "Learn more about User Permissions.",
  },
  plan: "Plan",
  service: "Service",
  alert: "Alert",
  remove: "Remove",
  repeats: "Repeats",
  saveChanges: "Save Changes",
  reset: "Reset",
  one: "One",
  two: "Two",
  three: "Three",
  emailInvalid: "Invalid email {emails} | Invalid emails: {emails}",
  errorAlertContactInfo: "Please contact support if this issue persists",
  errorLoadingData: "There was an error loading data for this modem",
  pleaseTryAgain: "Please try again later or choose a different period with the date picker.",
  noGPSData: "No GPS Data Available",
  oneweb: {
    usage: "Terminal Data Usage",
    beta: "Beta",
    usageTooltip:
      "OneWeb usage data is in beta and should not be relied upon for accurate indications of service usage. Data in Compass is for monitoring purposes and not service affecting.",
    usageDisclaimer:
      "OneWeb usage data is currently being trialed for estimation purposes only and should not be relied upon for accurate usage data. Statistics will likely be missing, undercounted or delayed. Final amounts in monthly invoices are accurate.",
  },
  ongoingAlertLegend: "Bars in red indicate ongoing alerts",
  activityInfo: "Activity History Info",
  activityHistoryInfo:
    "Activity history shows a record of any service change actions on each of your Starlink kits. This log only shows actions taken within Compass by a Compass user. Requests sent to the Speedcast Network Operations Center will not be reflected in this log.",
};
